module.exports = __webpack_public_path__ + "img/20160702-194104-1.f10c207b.jpg";